@if (form) {
    <form [formGroup]="form" class="w-100 h-fit-content" fxLayout="column" fxLayoutAlign="start start">
        <mat-accordion class="w-100">
            @for (trendStatisticForm of form.controls?.trendStatistics?.controls; track trackByTrendStatisticIndex(index, trendStatisticForm); let
                index = $index; let first = $first; let last = $last) {
                <af-trend-statistic-expansion-panel
                    [trendStatistic]="trendStatistics && trendStatistics[index]"
                    [trendStatisticForm]="trendStatisticForm"
                    [expanded]="!Spinner.isShown('initForms') && last"
                    [showDeleteButton]="showDeleteButton"
                    [index]="index"
                    [viewIndex]="trendStatisticForm.controls.id.value"
                    (deleteTrendStatisticListener)="deleteTrendStatistic($event)"
                />
            }
        </mat-accordion>

        <div fxLayout="row" fxLayoutAlign="start center" class="mt-40">
            <ui-kit-button type="secondary"
               (clickListener)="previousStep.emit()"
               [label]="'i18n_af_buttonBack' | translate"/>
        </div>
    </form>
}
